<script>
/** Utilitites */
import {mapState,mapMutations} from 'vuex'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import ReportingGroupApi from '../../api/ReportingGroupApi'
import ReportingEntityApi from '../../api/ReportingEntityApi'
import ReportingUnitApi from '../../api/ReportingUnitApi'
/** UI Components */
import { Collapse } from 'buefy/dist/components/collapse'
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Loading } from 'buefy/dist/components/loading'
import { Modal } from 'buefy/dist/components/modal'
import { Switch } from 'buefy/dist/components/switch'
import { Table,TableColumn } from 'buefy/dist/components/table'
/** Form Components */
import AddReportingGroupForm from '../../components/AddReportingGroupForm'
import EditReportingGroupForm from '../../components/EditReportingGroupForm'
import AddReportingEntityForm from '../../components/AddReportingEntityForm'
import EditReportingEntityForm from '../../components/EditReportingEntityForm'
import ReportingUnitsView from './ReportingUnitsView'

export default {
    name : "ReportingGroupsView",
    components: {
        'b-collapse' : Collapse,
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-loading' : Loading,
        'b-modal' : Modal,
        'b-switch' : Switch,
        'b-table' : Table,
        'b-table-column' : TableColumn,
        'AddRepGroupForm' : AddReportingGroupForm,
        'EditRepGroupForm' : EditReportingGroupForm,
        'AddRepEntityForm' : AddReportingEntityForm,
        'RenameEntityForm' : EditReportingEntityForm,
        'ReportingUnitsView' : ReportingUnitsView
    },
    computed : {
        ...mapState({
            reportingGroups : "reportingGroups",
            profile : "userProfile",
            token : "xOreAuth"
        }),
        filterReportingGroups(){
            // Filters grouping
            if (this.searchGroupKeyword.trim().length > 2) {
                var searchExp = new RegExp(this.searchGroupKeyword,"i");
                var list = this.reportingGroups.filter(function(group){
                    var sublist = group.reportingEntities.filter(entity=>{
                        return (entity.reportingEntity.match(searchExp));
                    });
                    return sublist.length
                }) 
                return list;
            }
            else {
                return this.reportingGroups;
            }
        }
    },
    data(){
        return {
            checkedRowsInGroup : [],
            searchGroupKeyword: "",
            selectedEntity : null,
            showAddRepGroup : false,
            showEditRepGroup : false,
            repGroupToEdit : null,
            repEntityToRename : null,
            showAddRepEntity : false,
            showRepEntityUnits : false,
            showRenameRepEntity : false,
            showDetailIcon : false,
            isLoading : false,
            isFullPage : false,
            usedColors : []
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        this.isTokenValid();
    },
    mounted(){
        // this.$refs['groupIdx1'][0].open = false;
        // this.$refs['groupIdx2'][0].open = false;
    },
    methods: {
        ...mapMutations({
            clearAppData : "clearAppData",
            setRepGroupData: "updateReportingGroups", 
            setProfile : "updateUserProfile"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                                this.getData();
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getData(){
            this.usedColors = [];
            this.isLoading = true;
            ReportingGroupApi.getAllData()
            .then(response => {
                if (response.data) {
                    if (!response.data.error) {
                        let rgdata = response.data;
                        rgdata.forEach(rg=>{
                            /** Convert Date */
                            rg.dateAdded = AppResourceUtil.convertDate(rg.dateAdded)
                            rg.dateLastUpdated = AppResourceUtil.convertDate(rg.dateLastUpdated)

                            if (rg.reportingEntities.length > 0) {
                                rg.reportingEntities.forEach(re=>{
                                    /** Convert Date */
                                    re.dateAdded = AppResourceUtil.convertDate(re.dateAdded)
                                    re.dateLastUpdated = AppResourceUtil.convertDate(re.dateLastUpdated)

                                    if (re.reportingUnits.length > 0) {
                                        re.reportingUnits.forEach(ru=>{
                                            /** Convert Date */
                                            ru.dateAdded = AppResourceUtil.convertDate(ru.dateAdded)
                                            ru.dateLastUpdated = AppResourceUtil.convertDate(ru.dateLastUpdated)
                                        })
                                    }
                                })
                            }
                        })
                        this.setRepGroupData(rgdata);
                        
                        this.usedColors = rgdata.map(g=>{
                            return g.repGroupTagClass;
                        });
                        /* 
                        Check if there are query parameters to filter the data set
                        Possible query parameters:
                            action : 'addRepUnit'
                            repEntityId 
                            repEntity : reportingEntity
                        */
                        var queryParams = this.$router.currentRoute.query;
                        
                        if (queryParams.action=='addRepUnit') {
                            if (queryParams.repEntity) {
                                this.searchGroupKeyword = decodeURIComponent(queryParams.repEntity);
                            }
                        }
                        this.isLoading = false;
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ReportingGroup.getAllData');
                    }
                }
            })
            .catch(error => {
                this.isLoading = false;
                this.promptServerError(error,'ReportingGroup.getAllData');
            });
        },
        filterRepEntities(repEntities) {
            if (this.searchGroupKeyword.trim().length > 2) {
                var searchExp = new RegExp(this.searchGroupKeyword,"i");
                return repEntities.filter(entity=>{
                    return (entity.reportingEntity.match(searchExp));
                });
            }
            else {
                return repEntities;
            }
        },
        // Reporting Group Methods
        openAddRepGroup(){
            this.showAddRepGroup = true;
        },
        closeAddRepGroup(){
            // confirm close, if there's data in modal
            // and is not yet saved
            this.showAddRepGroup = false;
        },
        addRepGroup(newRepGroup){
            if (newRepGroup.name.trim()=="") {
                return;
            }
            if (newRepGroup.tagName.trim()=="") {
                newRepGroup.tagName = newRepGroup.name;
            }
            ReportingGroupApi.add({
                reportingGroup : newRepGroup.name,
                repGroupTagClass : newRepGroup.repGroupTagClass,
                tagName : newRepGroup.tagName,
                isActive : newRepGroup.isActive,
                addedBy : this.profile.userId
            })
            .then(response=>{
                if (response.data) {
                    this.showAddRepGroup = false;
                    if (!response.data.error) {
                        this.getData();
                    }
                    else {
                        this.promptServerError({response},'ReportingGroup.add');
                    }
                }
            })
            .catch(error=>{
                this.showAddRepGroup = false;
                this.promptServerError(error,'ReportingGroup.add');
            });
        },
        openEditRepGroup(group){
            this.repGroupToEdit = group;
            this.showEditRepGroup = true;
        },
        closeEditRepGroup(){
            // confirm close, if there's data in modal
            // and is not yet saved
            this.showEditRepGroup = false;
        },
        updateRepGroup(repGroup){
            if (repGroup.reportingGroup.trim()=="") {
                return;
            }
            if (repGroup.repGroupId===undefined) {
                return;
            }
            if (repGroup.tagName.trim()=="") {
                repGroup.tagName = repGroup.reportingGroup;
            }
            ReportingGroupApi.update({
                reportingGroup : repGroup.reportingGroup,
                repGroupId : repGroup.repGroupId,
                repGroupTagClass : repGroup.repGroupTagClass,
                tagName : repGroup.tagName,
                isActive : repGroup.isActive,
                updatedBy : this.profile.userId
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.showEditRepGroup = false;
                        this.getData();
                    }
                    else {
                        this.showEditRepGroup = false;
                        this.promptServerError({response},'ReportingGroup.update');
                    }
                }
            })
            .catch(error=>{
                this.showEditRepGroup = false;
                this.promptServerError(error,'ReportingGroup.update');
            });
        },
        confirmDeleteRepGroup(repGroup){
            let count = repGroup.reportingEntities.length;
            if (count > 0) {
                let message = 'There are <b>'+repGroup.reportingEntities.length+' reporting entities</b> that are already linked to '+repGroup.reportingGroup+'. Delete is no longer allowed.';
                if (count==1) {
                    message = 'A reporting entity is already linked to '+repGroup.reportingGroup+'. Delete is no longer allowed.';
                }

                this.$dialog.alert({
                    title: 'Unable to delete',
                    message,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa'
                })
            }
            else {
                // Show 'Confirmation' if there are no forms this entity
                this.$dialog.confirm({
                    title: 'Delete Reporting Group',
                    message: 'Are you sure you want to <b>delete</b> '+repGroup.reportingGroup+'? This action cannot be undone.',
                    confirmText: 'Delete Reporting Group',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => this.deleteRepGroup(repGroup)
                })
            }
        },
        deleteRepGroup(repGroup) {
            ReportingGroupApi.delete(repGroup.repGroupId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.getData();
                    }
                    else {
                        if (response.data.error.hasOwnProperty('code') &&
                            response.data.error.code==220) {
                            this.$dialog.alert({
                                title: 'Error: Unable to delete',   
                                message: response.data.error.message,
                                type: 'is-danger'
                            });
                            return false;
                        }
                        this.promptServerError({response},'ReportingGroup.delete');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingGroup.delete');
            });
        },

        // Reporting Entity Methods
        openAddRepEntity(group){
            this.repGroupToEdit = group;
            this.showAddRepEntity = true;
        },
        closeAddRepEntity(){
            this.showAddRepEntity = false;
        },
        addRepEntity(entityData){
            // Add addedBy property
            entityData.forEach(entity=>{
                entity.addedBy = this.profile.userId;
            });

            ReportingEntityApi.add(entityData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.getData();
                        this.showAddRepEntity = false;
                    }
                    else {
                        this.showAddRepEntity = false;
                        this.promptServerError({response},'ReportingEntity.add');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingEntity.add');
            });
        },
        openRenameRepEntity(entity){
            this.repEntityToRename = entity;
            this.showRenameRepEntity = true;
        },
        closeRenameRepEntity(){
            this.showRenameRepEntity = false;
        },
        renameRepEntity(entityData){
            entityData.updatedBy = this.profile.userId;
            entityData.updateField = "reportingEntity";
            ReportingEntityApi.rename(entityData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.getData();
                        this.showRenameRepEntity = false;
                    }
                    else {
                        this.showRenameRepEntity = false;
                        this.promptServerError({response},'ReportingEntity.update');
                    }
                }
            })
            .catch(error=>{
                this.showRenameRepEntity = false;
                this.promptServerError(error,'ReportingEntity.update');
            });
        },

        confirmDeactivateRepEntity(entity){
            // Check if action is activate or deactivate
            if (entity.isActive==1) { 
                // Action is Deactivate
                console.log(entity)
                let unitsCount = entity.reportingUnits.length;
                if (unitsCount > 0) { // Originally, number of forms.
                    // Show 'Alert' if there are forms for this reporting entity
                    // Cannot deactivate this reporting entity since there are forms registered 
                    let message = 'There are reporting units ('+unitsCount+') that are already linked to '+entity.reportingEntity+'. <b>Deactivation is no longer allowed</b>.';
                    if (unitsCount == 1) {
                        message = 'A reporting unit is already linked to '+entity.reportingEntity+'. <b>Deactivation is no longer allowed</b>.';
                    }

                    this.$dialog.alert({
                        title: 'Unable to deactivate',
                        message,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa'
                    })
                }
                else {
                    // Show 'Confirmation' if there are no forms this entity
                    this.$dialog.confirm({
                        title: 'Deactivate Reporting Entity',
                        message: 'Are you sure you want to <b>deactivate</b> '+entity.reportingEntity+'? This action cannot be undone.',
                        confirmText: 'Deactivate Reporting Entity',
                        type: 'is-danger',
                        hasIcon: true,
                        onConfirm: () => this.deactivateRepEntity(entity)
                    })
                }

            }
            else {
                // Action is Activate
                this.activateRepEntity(entity);
            }
        },
        activateRepEntity(entityData){
            var newEntityData = {};
            this.$set(newEntityData,'repEntityId',entityData.repEntityId);
            this.$set(newEntityData,'updateField','isActive');
            this.$set(newEntityData,'action','activate');
            this.$set(newEntityData,'isActive',entityData.isActive);
            this.$set(newEntityData,'updatedBy',this.profile.userId);
            
            ReportingEntityApi.activate(newEntityData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.getData();
                    }
                    else {
                        this.promptServerError({response},'ReportingEntity.update');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingEntity.update');
            });
        },
        deactivateRepEntity(entityData) {
            var newEntityData = {};
            this.$set(newEntityData,'repEntityId',entityData.repEntityId);
            this.$set(newEntityData,'updateField','isActive');
            this.$set(newEntityData,'action','deactivate');
            this.$set(newEntityData,'isActive',entityData.isActive);
            this.$set(newEntityData,'updatedBy',this.profile.userId);

            ReportingEntityApi.deactivate(newEntityData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.getData();
                    }
                    else {
                        this.promptServerError({response},'ReportingEntity.update');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingEntity.update');
            });
        },

        confirmDeleteRepEntity(entity){   
            if (entity.forms > 0 || entity.numUnits > 0) {
                // Show 'Alert' if there are forms for this reporting entity
                // Cannot deactivate this reporting entity since there are forms registered 
                let message = 'There are reporting units ('+entity.numUnits+') that are already linked to '+entity.reportingEntity+'. <b>Delete is no longer allowed</b>.';
                if (entity.numUnits==1) {
                    message = 'A reporting unit is already linked to '+entity.reportingEntity+'. <b>Delete is no longer allowed</b>.';
                }

                this.$dialog.alert({
                    title: 'Unable to delete',
                    message,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa'
                })
            }
            else {
                // Show 'Confirmation' if there are no forms this entity
                this.$dialog.confirm({
                    title: 'Delete Reporting Entity',
                    message: 'Are you sure you want to <b>delete</b> '+entity.reportingEntity+'? This action cannot be undone.',
                    confirmText: 'Delete Reporting Entity',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => this.deleteRepEntity(entity)
                })
            }
        },
        deleteRepEntity(entityData){
            ReportingEntityApi.delete(entityData.repEntityId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.getData();
                    }
                    else {
                        this.promptServerError({response},'ReportingEntity.delete');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingEntity.delete');
            });     
        },

        // Reporting Units Methods
        toggleRow(row,reference) {
            this.$refs[reference][0].toggleDetails(row);
        },
        openRepUnits(row){
            this.selectedEntity = row;
            this.showRepEntityUnits = true;
        },
        closeRepUnits(){
            this.showRepEntityUnits = false;
        },
        addRepUnits(entity){
            /* For table-detail implementation */
            if (entity.reportingUnits) {
                var newUnits = entity.reportingUnits.filter(unit=>{
                    return (unit.isNew && unit.reportingUnit.trim()!="")
                });
                if (newUnits.length > 0) {
                    // Add addedBy property & repEntityId
                    newUnits.forEach(unit=>{
                        unit.addedBy = this.profile.userId;
                        unit.repEntityId = entity.repEntityId;
                        delete unit.isNew;
                    });
                    ReportingUnitApi.add(newUnits)
                    .then(response=>{
                        if (response.data) {
                            if (!response.data.error) {
                                this.getData();
                            }
                            else {
                                this.promptServerError({response},'ReportingUnit.add');
                            }
                        }
                    })
                    .catch(error=>{
                        this.promptServerError(error,'ReportingUnit.add');
                    });
                }
            }
    
            /* For modal implementation */
            // unitData.forEach(unit=>{
            //     unit.addedBy = this.profile.userId;
            // });

            // ReportingUnitApi.add(unitData)
            // .then(response=>{
            //     this.getData();
            //     this.showRepEntityUnits = false;
            // })
            // .catch(error=>{
            //     // show error
            // })
        },

        addRow(entity){
            entity.reportingUnits.push({
                reportingUnit : "",
                isActive : true,
                isNew : true
            })
        },
        deleteRow(entity,unitProp){
            if (unitProp.row.isNew==true) {
                entity.reportingUnits.splice(unitProp.index,1);
            }
            else {
                // Show confirmation 
                this.$dialog.confirm({
                    title: 'Delete Reporting Unit',
                    message: 'Are you sure you want to <b>delete</b> '+unitProp.row.reportingUnit+'? This action cannot be undone.',
                    confirmText: 'Delete Reporting Unit',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => this.deleteRepUnit(unitProp.row)
                })
            }
        },
        triggerClose(row,reference) {
            this.$refs[reference][0].toggleDetails(row);

            // Eventually, check if there are unsaved changes
            // Show warning/prompt 
            // Allow user to save or discard unsaved changes
        },
        deleteRepUnit(unit){
            ReportingUnitApi.delete(unit.repUnitId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.getData();
                    }
                    else {
                        this.promptServerError({response},'ReportingUnit.delete');
                    }
                }
                // Add to logs
            })
            .catch(error=>{
                // show error
                this.promptServerError(error,'ReportingUnit.delete');
            });
        },
        editRepUnit(entity,unitProp){
            unitProp.row.editView = !unitProp.row.editView;
            // Stores changes to another field 
            // This is to allow reverting changes, when cancelled
            unitProp.row.tempRepUnitData = {};
            this.$set(unitProp.row.tempRepUnitData,'reportingUnit',unitProp.row.reportingUnit)
            this.$set(unitProp.row.tempRepUnitData,'isActive',unitProp.row.isActive)
        },
        closeEditRepUnit(unitProp){
            unitProp.row.editView = false;
            delete unitProp.row.tempRepUnitData;
            // Eventually, check if there are unsaved changes
            // Show warning/prompt 
            // Allow user to save or discard unsaved changes
        },
        updateRepUnit(unit){

            var newUnitData = {};
            newUnitData.updatedBy = this.profile.userId;
            this.$set(newUnitData,'repUnitId',unit.repUnitId);
            this.$set(newUnitData,'reportingUnit',unit.tempRepUnitData.reportingUnit);
            this.$set(newUnitData,'isActive',unit.tempRepUnitData.isActive);
            
            ReportingUnitApi.update(newUnitData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.getData();
                    }
                    else {
                        this.promptServerError({response},'ReportingUnit.update');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingUnit.update');
            });
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title">Reporting Groups, Entities, and Units</p>

        <section class="section no-padd--top"> 
            <!-- Filter Options /Search -->
            <div class="columns">
                <div class="column">
                    <div class="field is-grouped">
                        <b-field
                            v-if="reportingGroups.length > 0">
                            <b-input placeholder="Search"
                                type="search"
                                icon="magnify"
                                v-model="searchGroupKeyword">
                            </b-input>
                        </b-field>
                        <button type="button"
                            class="button is-primary"
                            v-on:click="openAddRepGroup">
                            <span class="icon">
                                <i class="fas fa-plus"></i>
                            </span>
                            <span>Add Reporting Group</span>
                        </button>
                    </div>
                </div>
            </div>

            <section class="base-box--loading"
                v-if="isLoading">
                <b-loading 
                    v-bind:is-full-page="isFullPage" 
                    v-bind:active.sync="isLoading"
                    >
                    <b-icon
                        pack="fas"
                        icon="sync-alt"
                        size="is-medium"
                        custom-class="fa-spin">
                    </b-icon>
                    &nbsp;&nbsp;&nbsp;
                    <span class="title is-5">Loading data</span>
                </b-loading>
            </section>

            <section class="section no-padd app-view app-view--admin"
                v-if="reportingGroups.length > 0 && !isLoading">
                
                <b-collapse class="card"
                    v-for="(group,groupIdx) in filterReportingGroups"
                    v-bind:key="groupIdx"
                    v-bind:ref="'groupIdx'+groupIdx">
                    <div 
                        slot="trigger"
                        slot-scope="props"
                        class="card-header collapse-header">
                        
                        <div class="card-header-title is-title collapse-title">
                            <p>{{group.reportingGroup}} ({{filterRepEntities(group.reportingEntities).length}})</p>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <div class="buttons">
                                <a class="button is-light tooltip is-tooltip-right"
                                    data-tooltip="Add Reporting Entity"
                                    v-on:click.stop.prevent="openAddRepEntity(group)">
                                    <span class="icon">
                                        <i class="fas fa-plus"></i>
                                    </span>
                                </a>

                                <!-- Uncomment to restore Delete group feature -->
                                <a class="button is-light tooltip is-tooltip-right"
                                    data-tooltip="Delete"
                                    v-on:click.stop.prevent="confirmDeleteRepGroup(group)">
                                    <span class="icon">
                                        <i class="fas fa-trash"></i>
                                    </span>
                                </a>
                            
                                <a class="button is-light tooltip is-tooltip-right"
                                    data-tooltip="Edit"
                                    v-on:click.stop.prevent="openEditRepGroup(group)">
                                    <span class="icon">
                                        <i class="fas fa-pen"></i>
                                    </span>
                                </a>

                                <b-dropdown 
                                    aria-role="list" 
                                    position="is-bottom-left"
                                    @click.native.stop>
                                    <button type="button"
                                        class="button is-small is-light"
                                        slot="trigger"
                                        role="button"
                                        >
                                        <span class="icon fa-sm">
                                            <i class="fas fa-ellipsis-h fa-lg"></i>
                                        </span>
                                    </button>
                                    <b-dropdown-item aria-role="listitem">
                                        <div>
                                            <strong>Last updated by: </strong> {{group.lastUpdatedByName}}<br/>
                                            <strong>Last updated on: </strong> {{group.dateLastUpdated}}
                                        </div>
                                        <hr class="dropdown-divider">
                                        <div>
                                            <strong>Added by: </strong> {{group.addedByName}}<br/>
                                            <strong>Date added: </strong> {{group.dateAdded}}
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>

                                <!-- <a class="button is-success tooltip is-tooltip-right"
                                    data-tooltip="Generate Validation Card"
                                    v-on:click.stop.prevent="openEditRepGroup(group)">
                                    <span class="icon">
                                        <i class="fas fa-location-arrow"></i>
                                    </span>
                                    <span>Generate Validation Card</span>
                                </a> -->

                                <!-- <a class="button is-link is-inverted tooltip is-tooltip-right"
                                    data-tooltip="Deactivate"
                                    v-on:click.stop.prevent="deactivate(form)">
                                    <span class="icon">
                                        <i class="fas fa-ban"></i>
                                    </span>
                                </a> -->
                                <!-- &nbsp;&nbsp; <p>{{group.reportingGroup}} ({{group.reportingEntities.length}})</p> -->
                            </div>
                            <!-- &nbsp;&nbsp;&nbsp;&nbsp;  -->
                            <!-- <p>{{group.reportingGroup}} ({{group.reportingEntities.length}})</p>        -->
                        </div>
                        
                        <!-- Actions -->
                       

                        <a class="card-header-icon">
                            <b-icon
                                :icon="props.open ? 'menu-up' : 'menu-down'">
                            </b-icon>
                        </a>
                    </div>

                    <div>
                        <!-- table here -->
                        <b-table
                            v-bind:data="group.reportingEntities.length==0 ? [] : filterRepEntities(group.reportingEntities)"
                            v-bind:checked-rows.sync="checkedRowsInGroup"
                            v-bind:is-row-checkable="(row) => row.repEntityId"                            
                            v-bind:ref="'entityTable'+groupIdx"
                            detailed
                            detail-key="repEntityId"
                            v-bind:show-detail-icon="showDetailIcon">

                            <!-- Reporting Entities Section -->
                            <template
                                slot-scope="props">
                                <b-table-column
                                    field="repEntityId"
                                    label="ID"
                                    width="50"
                                    sortable
                                    centered
                                    numeric>
                                    {{props.row.repEntityId}}
                                </b-table-column>

                                <b-table-column
                                    field=""
                                    label="Options"
                                    width="50"
                                    centered>
                                    <b-dropdown>
                                        <button type="button"
                                            class="button is-small is-light"
                                            slot="trigger"
                                            role="button">
                                            <span class="icon fa-sm">
                                                <i class="fas fa-ellipsis-v fa-lg"></i>
                                            </span>
                                        </button>

                                        <b-dropdown-item
                                            v-on:click="toggleRow(props.row,'entityTable'+groupIdx)">
                                            <!-- v-on:click="openRepUnits(props.row)"> -->
                                            <b-icon size="fa-sm" 
                                                pack="fas"
                                                icon="plus">
                                            </b-icon>
                                            Add Reporting Unit
                                        </b-dropdown-item>

                                        <b-dropdown-item
                                            v-on:click="openRenameRepEntity(props.row)">
                                            <b-icon size="fa-sm" 
                                                pack="fas"
                                                icon="pen">
                                            </b-icon>
                                            Rename
                                        </b-dropdown-item>

                                        <hr class="dropdown-divider">

                                        <b-dropdown-item
                                            v-on:click="confirmDeactivateRepEntity(props.row)">
                                            <b-icon size="fa-sm" 
                                                pack="fas"
                                                icon="ban">
                                            </b-icon>
                                            {{props.row.isActive==true ? 'Deactivate' : 'Activate' }}
                                        </b-dropdown-item>
                                      
                                        <b-dropdown-item
                                            v-on:click="confirmDeleteRepEntity(props.row)">
                                            <b-icon size="fa-sm" 
                                                pack="fas"
                                                icon="trash">
                                            </b-icon>
                                            Delete permanently
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </b-table-column>

                                <b-table-column
                                    field="reportingEntity"
                                    label="Reporting Entity">
                                    {{props.row.reportingEntity}}
                                </b-table-column>

                                <b-table-column
                                    field="numUnits"
                                    label="No. of Units"
                                    width="150"
                                    centered
                                    sortable    
                                    numeric>
                                    <!-- <a class="button is-text"
                                        v-on:click="openRepUnits(props.row)">{{props.row.numUnits}}</a> -->
                                    <a class="button is-text"
                                        v-on:click="toggleRow(props.row,'entityTable'+groupIdx)">{{props.row.numUnits}}</a>
                                </b-table-column>

                                <b-table-column
                                    field="repGroupTagClass"
                                    label="Reporting Group"
                                    width="200">
                                    <span class="tag"
                                        v-bind:class="props.row.repGroupTagClass">{{props.row.reportingGroup}}</span>
                                </b-table-column>

                                <b-table-column
                                    field="isActive"
                                    label="Active"
                                    width="100"
                                    centered>
                                    {{props.row.isActiveStr}}
                                    <!-- {{props.row.isActive}} -->
                                </b-table-column> 

                                <b-table-column
                                    label="Logs"
                                    width="50"
                                    centered>
                                    <b-dropdown 
                                        aria-role="list" 
                                        position="is-bottom-left">
                                        <button type="button"
                                            class="button is-small is-light"
                                            slot="trigger"
                                            role="button">
                                            <span class="icon fa-sm">
                                                <i class="fas fa-ellipsis-h fa-lg"></i>
                                            </span>
                                        </button>
                                        <b-dropdown-item aria-role="listitem">
                                            <div>
                                                <strong>Last updated by: </strong> {{props.row.lastUpdatedByName}}<br/>
                                                <strong>Last updated on: </strong> {{props.row.dateLastUpdated}}
                                            </div>
                                            <hr class="dropdown-divider">
                                            <div>
                                                <strong>Added by: </strong> {{props.row.addedByName}}<br/>
                                                <strong>Date added: </strong> {{props.row.dateAdded}}
                                            </div>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </b-table-column>             
                            </template>

                            <!-- If there are no reporting entities -->
                            <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                icon="emoticon-sad"
                                                size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>No reporting entities available.</p>
                                    </div>
                                </section>
                            </template>

                            <!-- Reporting Units / Details section -->
                            <template 
                                slot="detail"
                                slot-scope="props">

                                <b-table
                                    v-bind:data="props.row.reportingUnits ? props.row.reportingUnits : []">
                                    <template
                                        slot-scope="subprops">

                                        <b-table-column
                                            field=""
                                            label="Option"
                                            width="150"
                                            centered>
                                            <button
                                                class="button is-white"
                                                type="button"
                                                v-on:click="deleteRow(props.row,subprops)">
                                                <span class="icon">
                                                    <i class="fas fa-trash"></i>
                                                </span>
                                            </button>
                                            <button
                                                class="button is-white"
                                                type="button"
                                                :disabled="!(subprops.row.isNew==false && subprops.row.editView==false)"
                                                v-on:click="editRepUnit(props.row,subprops)">
                                                <span class="icon">
                                                    <i class="fas fa-pen"></i>
                                                </span>
                                            </button>
                                        </b-table-column>

                                        <b-table-column
                                            field="reportingUnit"
                                            label="Reporting Unit">
                                            <span
                                                v-if="subprops.row.isNew==false && subprops.row.editView==false">
                                                {{subprops.row.reportingUnit}}
                                            </span>
                                            <b-field
                                                v-if="subprops.row.isNew==false && subprops.row.editView==true">
                                                <b-input 
                                                    v-model="subprops.row.tempRepUnitData.reportingUnit"
                                                    type="text"
                                                    value=""
                                                    required></b-input>
                                            </b-field>
                                            <b-field
                                                v-if="subprops.row.isNew==true">
                                                <b-input 
                                                    v-model="subprops.row.reportingUnit"
                                                    type="text"
                                                    value=""
                                                    required></b-input>
                                            </b-field>
                                        </b-table-column>

                                        <b-table-column
                                            field="isActive"
                                            label="Active"
                                            width="75"
                                            centered>
                                            <b-field
                                                v-if="subprops.row.isNew==true">
                                                <b-switch v-model="subprops.row.isActive">
                                                    {{subprops.row.isActive==true ? "Yes" : "No" }}
                                                </b-switch>
                                            </b-field>
                                            <b-field
                                                v-if="subprops.row.isNew==false && subprops.row.editView==true">
                                                <b-switch v-model="subprops.row.tempRepUnitData.isActive">
                                                    {{subprops.row.tempRepUnitData.isActive==true ? "Yes" : "No" }}
                                                </b-switch>
                                            </b-field>
                                            <span
                                                v-if="subprops.row.isNew==false && subprops.row.editView==false">
                                                {{subprops.row.isActive==true ? "Yes" : "No" }}
                                            </span>
                                        </b-table-column>

                                        <b-table-column
                                            label="Logs"
                                            centered>
                                            <b-dropdown 
                                                v-if="subprops.row.repUnitId"
                                                aria-role="list" 
                                                position="is-bottom-left">
                                                <button type="button"
                                                    class="button is-small is-light"
                                                    slot="trigger"
                                                    role="button">
                                                    <span class="icon fa-sm">
                                                        <i class="fas fa-ellipsis-h fa-lg"></i>
                                                    </span>
                                                </button>
                                                <b-dropdown-item aria-role="listitem">
                                                    <div>
                                                        <strong>Last updated by: </strong> {{subprops.row.lastUpdatedByName}}<br/>
                                                        <strong>Last updated on: </strong> {{subprops.row.dateLastUpdated}}
                                                    </div>
                                                    <hr class="dropdown-divider">
                                                    <div>
                                                        <strong>Added by: </strong> {{subprops.row.addedByName}}<br/>
                                                        <strong>Date added: </strong> {{subprops.row.dateAdded}}
                                                    </div>
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </b-table-column>   

                                        <b-table-column
                                            field=""
                                            label=""
                                            class="has-text-right">
                                            
                                            <a class="button is-light"
                                                v-if="subprops.row.isNew==false && subprops.row.editView==true"
                                                v-on:click="closeEditRepUnit(subprops)">
                                                <span>Cancel</span>
                                            </a>
                                            
                                            <a class="button is-success"
                                                v-if="subprops.row.isNew==false && subprops.row.editView==true"
                                                v-on:click="updateRepUnit(subprops.row)">
                                                <span>Update</span>
                                            </a>
                                            
                                        </b-table-column>
                                    </template>
                                    <template slot="empty">
                                        <section class="section">
                                            <div class="content has-text-grey has-text-centered">
                                                <p>
                                                    <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                    </b-icon>
                                                </p>
                                                <p>No reporting units available.</p>
                                            </div>
                                        </section>
                                    </template>
                                </b-table>

                                <div class="has-text-left detail-btn-wrapper">
                                    <a class="button is-text"
                                        v-on:click="addRow(props.row)">
                                        <span>+ Add Row</span>
                                    </a>

                                    <a class="button is-light"
                                        v-on:click="triggerClose(props.row,'entityTable'+groupIdx)">
                                        <span>Cancel</span>
                                    </a>
                                    
                                    <a class="button is-success"
                                        v-on:click="addRepUnits(props.row)">
                                        <span>Submit</span>
                                    </a>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </b-collapse>
                
            </section>

            <!-- Empty State -->
            <section class="section no-padd app-view app-view--admin"
                v-if="reportingGroups.length==0 && !isLoading">
                <div
                    class="has-text-centered empty-state-box empty-state-box--white">
                    <div class="has-text-centered">

                        <p class="title is-5">There are no reporting groups found.</p>
                        <p class="subtitle">
                            To start adding reporting groups, click 'Add Reporting Group' button or click 
                            <a v-on:click="openAddRepGroup">here</a>.
                        </p>
                        
                    </div>

                </div>
            </section>
            
        </section>



        <!-- Modal: Add Reporting Group -->
        <b-modal
            v-bind:active.sync="showAddRepGroup"
            v-bind:width="640"
            v-on:close="closeAddRepGroup">
            <AddRepGroupForm
                v-bind:usedColors="usedColors"
                v-on:close="closeAddRepGroup"
                v-on:submit-rep-group="addRepGroup"/>
        </b-modal>

        <!-- Modal: Edit Reporting Group -->
        <b-modal
            v-bind:active.sync="showEditRepGroup"
            v-bind:width="640"
            v-on:close="closeEditRepGroup">
            <EditRepGroupForm
                v-bind:usedColors="usedColors"
                v-bind:data="repGroupToEdit"
                v-on:close="closeEditRepGroup"
                v-on:save-repgroup="updateRepGroup"/>
        </b-modal>

        <!-- Modal: Add Reporting Entities -->
        <b-modal
            v-bind:active.sync="showAddRepEntity"
            v-bind:width="1000"
            v-on:close="closeAddRepEntity">
            <AddRepEntityForm
                v-bind:repGroupData="repGroupToEdit"
                v-on:close="closeAddRepEntity"
                v-on:save-rep-entity="addRepEntity"/>
        </b-modal>

        <!-- Modal: Edit Reporting Entity -->
        <b-modal
            v-bind:active.sync="showRenameRepEntity"
            v-bind:width="640"
            v-on:close="closeRenameRepEntity">
            <RenameEntityForm
                v-bind:data="repEntityToRename"
                v-on:close="closeRenameRepEntity"
                v-on:submit-newname="renameRepEntity"/>
        </b-modal>

        <!-- Reporting Entity/Units View -->
        <!-- <b-modal
            v-bind:active.sync="showRepEntityUnits"
            v-bind:width="1000"
            v-on:close="closeRepUnits">
            <ReportingUnitsView
                v-bind:repEntityData="selectedEntity"
                v-on:close="closeRepUnits"
                v-on:save-rep-unit="addRepUnits"/>
        </b-modal> -->

    </section>
</template>

<style scoped>
.collapse-header {
    background-color: whitesmoke;
}
.detail-btn-wrapper {
    margin-top: 0.75em; 
}
</style>




// WEBPACK FOOTER //
// src/views/administration/ReportingGroupsView.vue